<template>
  <div class="page_all">
    <div class="return_link"></div>
    <div class="page_header">
      <div class="header_title">
        <div class="title">自治体管理</div>
        <div class="message">
          <div class="error">{{ message }}</div>
        </div>
      </div>
      <div>
        <button class="btn_plus" @click="openModal()">＋</button>
      </div>
    </div>
    <div class="page_main">
      <table class="tbl_main">
        <thead>
          <tr>
            <th class="th_municipality">自治体名</th>
            <th class="th_charge">担当</th>
            <th class="th_delete"></th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="muni in municipalities" v-bind:key="muni.municipality_key">
            <td class="td_municipality">
              {{ muni.prefecture_name }}/{{ muni.municipality_name }}
            </td>
            <td class="td_charge">
              <button class="btn_charge" v-on:click="municipalityCharge(muni.municipality_key)">担当</button>
            </td>
            <td class="btn_delete">
              <button class="btn_delete" v-on:click="municipalityDel(muni.municipality_key)">X</button>
            </td>
          </tr>
        </tbody>
      </table>
      <!-- 以下モーダルウィンドウ -->
      <modal v-if="showModal" @close="closeModal">
        <div class="modal_main">
          <table class="tbl_modal_search">
            <thead>
              <tr>
                <th class="th_modal_title">
                  <div>
                    <span>自治体選択</span>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
              <tr class="tr_modal">
                <div class="modal_search_title">
                  <label>条件を入力して検索し、追加する自治体を選択してください。</label>
                </div>
                <div class="modal_search">
                  <input type="text" class="modal_input_keyword" v-model.trim="$v.searchKeyword.$model" @keypress.enter="municipalitySearch(searchKeyword)" placeholder="団体コード、都道府県名、市区町村名"/>
                  <button :disabled="$v.$invalid" class="btn_general" v-on:click="municipalitySearch(searchKeyword)">検索</button>
                </div>
              </tr>
              <tr class="tr_modal">
                <td class="td_modal_message">
                  <div class="message">
                    <div v-if="$v.searchKeyword.$dirty">
                      <div class="error" v-if="!$v.searchKeyword.required">自治体名は必須入力です。</div>
                      <div class="error" v-if="!$v.searchKeyword.maxLength">自治体名は{{ $v.searchKeyword.$params.maxLength.max }}文字以内で入力してください。</div>
                    </div>
                  </div>
                </td>
              </tr>
              <tr class="tr_modal">
                <div class="modal_search_result">
                  <div class="modal_result_title">
                    <label>検索結果</label>
                  </div>
                  <table class="tbl_modal_search_result">
                    <thead>
                      <tr class="tr_modal">
                        <th class="th_modal_code">団体コード</th>
                        <th class="th_modal_prefectures">都道府県名</th>
                        <th class="th_modal_municipality">市区町村名</th>
                        <th class="th_modal_add"></th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="result in searchResult" v-bind:key="result.id" class="tr_modal">
                        <td class="td_modal">{{ result.municipality_id }}</td>
                        <td class="td_modal">{{ result.prefecture_name }}</td>
                        <td class="td_modal">{{ result.municipality_name }}</td>
                        <td class="td_modal">
                          <button :disabled="updating" class="btn_add" v-on:click="municipalityAdd(result.municipality_id)">追加</button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <tr class="tr_modal">
                    <div class="message_modal">
                      <div class="message">
                        <div class="error">{{ messageModal }}</div>
                      </div>
                    </div>
                  </tr>
                </div>
              </tr>
              <tr class="tr_modal">
                <div class="modal_btn_close">
                  <div></div>
                  <div>
                    <button class="btn_general" @click="closeModal">閉じる</button>
                  </div>
                </div>
              </tr>
            </tbody>
          </table>
        </div>
      </modal>
      <!-- ここまでモーダルウィンドウ -->
    </div>
    <confirm-dialog ref="deleteDialog" primary-label="削除" secondary-label="キャンセル"/>
  </div>
</template>

<script>
import { required, maxLength } from 'vuelidate/lib/validators'
import modal from '@/components/MunicipalityModal'
import ConfirmDialog from "@/components/ConfirmDialog";

export default {
  components: {
    modal,
    ConfirmDialog,
  },
  data: function() {
    return {
      municipalities: null,
      // 以下モーダル変数
      showModal: false,
      searchKeyword: "",
      searchResult: [],
      // エラーメッセージ
      message: "",
      messageModal: "",
      updating: false,
    }
  },
  mounted() {
    this.getMunicipalityList()
  },
  methods: {
    async getMunicipalityList() {
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'municipality/list', {
        params: {}
      })
      this.municipalities = response.data
    },
    async municipalityAdd(municipality_id) {
      this.updating = true;
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'municipality/add', {
          municipality_id: municipality_id,
          admin_user: this.$store.getters.getStateAdminUser
        })
        this.closeModal()
        this.getMunicipalityList()
      } catch (err) {
        this.messageModal = err.response.data.errorMessage
      }
      this.updating = false;
    },
    async municipalityDel(municipality_key) {
      const municipality = this.municipalities && this.municipalities.find(municipality => municipality.municipality_key === municipality_key) || null;
      if (!municipality) {
        return;
      }
      const result = await this.$refs.deleteDialog.asyncShow(`${municipality.prefecture_name}/${municipality.municipality_name}を削除してよろしいですか？`);
      if (!result) {
        return;
      }
      try {
        await this.$axios.post(process.env.VUE_APP_API_BASEURL + 'municipality/del', {
          municipality_key: municipality_key,
          admin_user: this.$store.getters.getStateAdminUser
        })
        this.getMunicipalityList()
      } catch (err) {
        this.message = err.response.data.errorMessage
      }
    },
    async municipalitySearch(keyword) {
      this.messageModal = ""
      const response = await this.$axios.get(process.env.VUE_APP_API_BASEURL + 'municipality/search', {
        params: {
          keyword: keyword
        }
      })
      this.searchResult = response.data
    },
    municipalityCharge: function(municipality_key) {
      // 自治体コードをStoreにセット
      this.$store.commit('setStateSelectMunicipalityKey', municipality_key)
      this.$router.push({ name: 'chargeList' })
    },
    openModal: function() {
      this.showModal = true
    },
		closeModal: function() {
      this.messageModal = ""
      this.searchKeyword = ""
      this.searchResult = []
      this.showModal = false
      // validationsモデルオブジェクトをリセット
      this.$v.searchKeyword.$reset()
    }
  },
  validations: {
    searchKeyword: {
      required,
      maxLength: maxLength(10)
    }
  }
}
</script>

<style scoped>
table th.th_charge {
  width: 60px;
}
table th.th_delete {
  width: 30px;
}
table td.td_municipality {
  text-align: left;
  padding-left: 10px;
  border-right: none;
}
table td.td_charge {
  border-left: none;
  border-right: none;
}
.btn_charge {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  width: 58px;
}
.btn_add {
  background-color: #FFFFFF;
  border: 1px #666666 solid;
  cursor: pointer;
  outline: none;
  appearance: none;
  height: 25px;
  font-size: 12px;
  width: 58px;
}

/* モーダル画面 自治体検索 */
table tr.tr_modal {
  border: none;
}
table th.th_modal_title {
  font-weight: normal;
  text-align: center;
  padding: 5px 0px 5px 0px;
}
.modal_search_title {
  width: 440px;
  text-align: left;
  padding: 10px 0px 0px 20px;
  font-size: 13px;
}
.tbl_modal_search {
  width: 480px;
  border-collapse: collapse;
  margin: 0 auto;
}
.modal_search {
  display: flex;
  justify-content: space-between;
  padding: 0px 20px 0px 20px;
}
.modal_input_keyword {
  width: 375px;
}
.modal_btn_close {
  display: flex;
  justify-content: space-between;
  border-top: 1px #666666 solid;
  background-color: #F7F2E0;
  padding: 3px 5px 3px 5px;
}
table td.td_modal_message {
  border: none;
  padding: 0px 0px 0px 20px;
}

/* モーダル画面 検索結果 */
.modal_main {
  max-height: 400px;
  overflow: auto;
}
.modal_result_title {
  width: 440px;
  text-align: left;
  padding: 0px 0px 0px 20px;
  font-size: 13px;
}
.modal_search_result {
  padding: 10px 0px 0px 0px;
}
.tbl_modal_search_result {
  width: 440px;
  border-collapse: collapse;
  margin: 0 auto;
  padding: 10px 20px 20px 20px;
}
table th.th_modal_code, .th_modal_prefectures, .th_modal_municipality {
  font-weight: normal;
  text-align: center;
}
table th.th_modal_code {
  width: 100px;
}
table th.th_modal_prefectures {
  width: 140px;
}
table th.th_modal_municipality {
  width: 140px;
}
table th.th_modal_add {
  width: 60px;
}
table td.td_modal {
  height: 25px;
}
.message_modal {
  padding: 0px 0px 10px 20px;
}
</style>